<template>
  <div>
    <Head title="Especialidades" />
    <div class="shadow_box rounded-lg p-6">
      <h1 class="mb-6 text-2xl text-gray-777 font-roboto uppercase">Especialidades</h1>
      <data-table
        v-if="loadTable"
        v-model:columns="columns"
        route="specialties/list"
        no-data-label="Nenhuma especialidade cadastrada"
        no-result-label="Nenhuma especialidade encontrada"
      >
        <template #table.cell.content.specialty_status="{ value, row }">
            <switch-input v-model="row.status" labelChecked="Ativo" labelUnchecked="Inativo" @click="changeStatus(row)" />
        </template>
        <template #grid.content.body.specialty_status="{ value, row }">
            <switch-input v-model="row.status" labelChecked="Ativo" labelUnchecked="Inativo" @click="changeStatus(row)" />
        </template>

        <template #table.cell.content.actions="{ value, row }">
            <div class="inline-grid grid-cols-2 gap-4 ">
                <span @click="openModalEdit(row)"><font-awesome-icon icon="fa-pen-to-square" class="text-blue-500 text-lg cursor-pointer" /></span>
                <span @click="openModalConfirmDelete(row)"><font-awesome-icon icon="fa-trash-can" class="text-red-600 text-lg cursor-pointer" /></span>
            </div>
        </template>
        <template #grid.content.body.actions="{ value, row }">
            <div class="inline-grid grid-cols-2 gap-4 ">
                <span @click="openModalEdit(row)"><font-awesome-icon icon="fa-pen-to-square" class="text-blue-500 text-lg cursor-pointer" /></span>
                <span @click="openModalConfirmDelete(row)"><font-awesome-icon icon="fa-trash-can" class="text-red-600 text-lg cursor-pointer" /></span>
            </div>
        </template>
    
        <template #after.reload-button>
            <button class="flex items-end font-roboto font-medium btn-blue uppercase" @click.prevent="openModalEdit({})">
            <font-awesome-icon icon="fa-plus" class="text-white text-lg mr-0 lg:mr-2" /><span class="hidden lg:block"> Adicionar Especialidade</span>
            </button>
        </template>
      </data-table>
    </div>
    <modal-delete ref="modalDelete" @confirm="reloadTable"></modal-delete>
    <modal-edit ref="modalEdit" title="Especialidades" url="specialties" @submitForm="reloadTable">
      <template #form="{item}">
        <text-input v-model="item.name" :error="item.errors.name" class="lg:pr-6 w-full lg:w-3/4" label="Nome" />
        <switch-input v-model="item.status" class="w-full mt-6 lg:mt-0 lg:w-1/4" label="Situação" labelChecked="Ativo" labelUnchecked="Inativo" />
      </template>
    </modal-edit>
  </div>
</template>

<script>
import { Head } from '@inertiajs/inertia-vue3'
import Layout from '@/Shared/Layout'
import LoadingButton from '@/Shared/LoadingButton'
import ModalDelete from '@/Shared/ModalDelete'
import ModalEdit from '@/Shared/ModalEdit'
import SwitchInput from '@/Shared/SwitchInput'
import TextInput from '@/Shared/TextInput'
import DataTable from '@/Shared/DataTable'

export default {
  components: {
    Head,
    LoadingButton,
    ModalDelete,
    ModalEdit,
    SwitchInput,
    TextInput,
    DataTable,
  },
  layout: Layout,
  data() {
    return {
      loadTable: true,
      columns: [
        {
          uniqid: 'specialty_name',
          label: 'Nome da especialidade',
          field: 'name',
          visible: true,
          sortable: true,
          sortOrder: 'asc',
          classes: 'px-4 py-3 border-b text-sm',
          headerClass: 'p-4 text-left',
        },
        {
          uniqid: 'specialty_status',
          label: 'Situação',
          field: 'status',
          visible: true,
          sortable: true,
          sortOrder: 'asc',
          classes: 'px-4 py-3 border-b text-sm',
          headerClass: 'p-4 text-left',
        },
        {
          uniqid: 'actions',
          label: 'Ações',
          field: 'id',
          visible: true,
          align: 'center',
          classes: 'py-3 border-b',
          headerClass: 'p-4',
        },
      ],
    }
  },
  methods: {
    changeStatus(item) {
      item.status = !item.status;
      this.$inertia.post("/specialties/update-status", item);
    },
    openModalConfirmDelete(item) {
      this.$refs.modalDelete.openModalDelete(item, `/specialties/${item.id}`, `Deseja realmente excluir a especialidade ${item.name}?`);
    },
    openModalEdit(item) {
      this.$refs.modalEdit.openModalEdit({
        id: item.id,
        name: item.name,
        status: item.status ?? true,
        errors: {}
      });
    },
    reloadTable() {
      this.loadTable = false;
      setTimeout(() => this.loadTable = true, 10);
    }
  },
}
</script>